
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronDoubleDownGoogle as ObiChevronDoubleDownGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-double-down-google.js';
 
 
 

 
 export const ObiChevronDoubleDownGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-double-down-google',
   elementClass: ObiChevronDoubleDownGoogleElement,
   events: {
     
   }
  });
 
 